import Marquee from "react-fast-marquee";

const ITEMS = [
  "Custom Cabinets",
  "Complete Renovations",
  "Beautiful Interiors",
  "Smart Storage",
  "Quality Craftsmanship",
  "Serving the GTA",
];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-primary text-primary-foreground py-5 overflow-hidden border-y border-primary/40"
    >
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-heading italic text-2xl md:text-3xl tracking-tight px-8">
              {item}
            </span>
            <span className="text-primary-foreground/60 text-lg">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
